<template>
  <div class="applicant_delete" @click="click">删除</div>
</template>

<script>
import { Loading } from 'element-ui';
import utils from '../../../libs/utils.js';
import orderingService from '../../../services/ordering-service';

export default {
  name: 'delete-applicant-id',
  model: {
    prop: 'deleteDialog',
    event: 'change',
  },
  props: {
    deleteDialog: {
      type: Boolean,
      default: false,
    },
    nowApplicant: {
      type: Number,
      default: null,
    },
    applicantId: {
      type: String,
      default: '',
    },
    orderId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    click() {
      utils.msgbox.confirm('确定要删除该申请人吗？', '删除申请人', {
        confirmButtonText: '　是　',
        cancelButtonText: ' 再想想 ',
        type: 'warning',
      }).then(() => {
        this.applicantDelete();
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      }, (e) => {
        if (e) console.log(e);
      });
    },
    applicantDelete() {
      const _this = this;
      _this.loadingInstance = Loading.service({
        target: '#application-form',
        text: '数据加载中',
      });
      orderingService.deleteApplicant(_this.nowApplicant, _this.orderId).then(() => {
        _this.$emit('ok', _this.nowApplicant);
        _this.loadingInstance.close();
      }).catch((e) => {
        if (e) console.log(e);
        _this.loadingInstance.close();
      });
    },
  },
};
</script>

<style lang="less">
.applicant_delete {
    font-size: 14px;
    color: #5e9be1;
    width: 100px;
    text-align: left;
    cursor: pointer;
    visibility: hidden;
    position: absolute;
    right: 160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/delete-applicant-id.vue